var DELAY_CLOSE = 0.1;
var DELAY_OPEN = 0.1;
var TOOLBAR_ANIMATION_DURATION = 50;

export { DELAY_CLOSE, DELAY_OPEN, TOOLBAR_ANIMATION_DURATION };
//# sourceMappingURL=constants.js.map
